import * as Yup from 'yup';
import { memo } from 'react';
import { compose } from 'redux';
import { withFormik } from 'formik';
//constants
import * as C from '../constants';
// utilities
import * as U from '../utilities';
// components
import { headerFileUploadStatusData } from '../components/app-layout/header/routines';
// forms
import { Fieldset, FormFooter } from '../components/forms';
// ui
import { Flex } from '../ui';
//////////////////////////////////////////////////

export const validationSchemaUploadFileObject = {
  [C.FIELD_DOCUMENT_UPLOAD]: Yup.mixed()
    .test(
      'file-format',
      U.getShouldBeFileLocaleTxt(),
      async value => {
        if (U.isNilOrEmpty(value)) return true;

        const fileExtension = value.name.split('.').pop().toLowerCase();

        return C.FILE_EXTENSIONS_REGEXP.test(`.${fileExtension}`);
      },
    )
    .required(U.getRequiredLocaleTxt()),
};

const initialValues = {
  [C.FIELD_DOCUMENT_UPLOAD]: null,
};

const validationSchema = Yup.object().shape(validationSchemaUploadFileObject);

const commonStyles = {
  width: 350,
};

const submitBtnStyles = {
  width: 350,
};

const fieldSettings = [
  {
    required: true,
    fieldType: 'file',
    inputStyles: commonStyles,
    label: 'labels.uploadFile',
    fieldName: C.FIELD_DOCUMENT_UPLOAD,
  },
];

const fieldsetStyles = {
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
};

const enhance = compose(
  withFormik({
    validationSchema,
    displayName: 'UPLOAD_FILE_FORM',
    mapPropsToValues: () => initialValues,
    handleSubmit: (values, { props }) => {
      const { dispatch, submitAction } = props;

      submitAction(values);

      setTimeout(() => { // eslint-disable-line
        dispatch(headerFileUploadStatusData());
      }, 3000);
    },
  }),
  memo,
);

const UploadFileForm = enhance(props => {
  const { submitText, handleSubmit, isSubmitting } = props;

  return (
    <form onSubmit={handleSubmit} data-testid='testid-UploadFileForm'>
      <Flex flexDirection='column'>
        <Fieldset
          {...U.getFormikProps(props)}
          fields={fieldSettings}
          fieldsetStyles={fieldsetStyles}
        />
        <FormFooter
          title={submitText}
          submitBtnStyles={submitBtnStyles}
          isSubmitting={isSubmitting}
        />
      </Flex>
    </form>
  );
});

export default UploadFileForm;
